var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-message",class:{
    left: _vm.float == 'left',
    right: _vm.float == 'right',
    'max-width': !_vm.fullWidth,
  }},[(_vm.arrow)?_c('div',{staticClass:"arrow"}):_vm._e(),_c('pre',{domProps:{"innerHTML":_vm._s(_vm.html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }